module.exports = __webpack_public_path__ + "img/Polygon.9c3c1211.png";